import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pp-lottery-winnings" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { ref } from "vue";
import { StringUtils } from "@sazka/utils/string-utils";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import { LotteryParser } from "@sazka/lotteries/js/utils/lottery-parser";
import { usePpWagerConfiguration } from "../../composables/use-wager-configuration";
import PpSpecialPrizeWinnings from "./pp-special-prize-winnings.vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { PpDraw } from "@/lotteries/services/model/draw";
import DsDropdown from "@sazka/design-system/src/forms/components/ds-dropdown.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-s10-winnings',
  props: {
    results: {}
  },
  setup(__props: any) {



const config = usePpWagerConfiguration().config;

const options = Array.from({ length: config.primaryBoardSize }, (_, index) => ({
    value: index,
    label: `SÁZKA NA ${config.primaryBoardSize - index} ${LotteryParser.getNumberLabel(
        config.primaryBoardSize - index
    ).toUpperCase()}`,
}));

const selectedOption = ref(0);

const winningOrdersGrid = [
    [
        [10, 200000, 300000],
        [9, 10000, 15000],
        [8, 500, 750],
        [7, 20, 30],
        [6, 10, 15],
        [5, 3, 6],
        [4, null, 2],
        [3, null, 2],
        [2, null, 2],
        [1, null, 6],
    ],
    [
        [9, 50000, 75000],
        [8, 2000, 3000],
        [7, 200, 300],
        [6, 20, 30],
        [5, 3, 6],
        [4, null, 2],
        [3, null, 2],
        [2, null, 2],
        [1, null, 7],
    ],
    [
        [8, 20000, 30000],
        [7, 400, 1000],
        [6, 40, 100],
        [5, 4, 15],
        [4, 1, 5],
        [3, null, 2],
        [2, null, 2],
        [1, null, 3],
    ],
    [
        [7, 4000, 6000],
        [6, 100, 200],
        [5, 10, 20],
        [4, 2, 10],
        [3, null, 4],
        [2, null, 3],
        [1, null, 3],
    ],
    [
        [6, 600, 1500],
        [5, 20, 50],
        [4, 2, 10],
        [3, 1, 5],
        [2, null, 5],
        [1, null, 5],
    ],
    [
        [5, 200, 400],
        [4, 16, 30],
        [3, 2, 10],
        [2, null, 5],
        [1, null, 5],
    ],
    [
        [4, 50, 120],
        [3, 8, 25],
        [2, null, 7],
        [1, null, 5],
    ],
    [
        [3, 16, 50],
        [2, 2, 20],
        [1, null, 5],
    ],
    [
        [2, 8, 50],
        [1, null, 10],
    ],
    [[1, 2, 40]],
];

const formatMultiple = (multiple: number) => (multiple ? `${StringUtils.formatNumber(multiple)}x` : "–––");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DsDropdown, {
      modelValue: selectedOption.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOption).value = $event)),
      options: _unref(options),
      id: "pp-lottery-winnings-dropdown"
    }, null, 8, ["modelValue", "options"]),
    _createVNode(DsTable, null, {
      default: _withCtx(() => [
        _createVNode(DsRow, null, {
          default: _withCtx(() => [
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Uhodnutá čísla")
              ])),
              _: 1,
              __: [1]
            }),
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Výherní násobek")
              ])),
              _: 1,
              __: [2]
            }),
            _createVNode(DsCell, { type: "th" }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Násobek s královskou hrou")
              ])),
              _: 1,
              __: [3]
            })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(winningOrdersGrid[selectedOption.value], (order, index) => {
          return (_openBlock(), _createBlock(DsRow, { key: index }, {
            default: _withCtx(() => [
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(order[0]), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: formatMultiple(order[1])
                  }, null, 8, _hoisted_2)
                ]),
                _: 2
              }, 1024),
              _createVNode(DsCell, null, {
                default: _withCtx(() => [
                  _createElementVNode("strong", {
                    innerHTML: formatMultiple(order[2])
                  }, null, 8, _hoisted_3)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(PpSpecialPrizeWinnings, {
      lottery: _unref(Lottery).stastnych10,
      specialPrizes: _ctx.results.specialPrizes
    }, null, 8, ["lottery", "specialPrizes"])
  ]))
}
}

})